<template>
  <div class="home-operate">
    <div class="home-operate__edit" @click="edit">编辑</div>
    <!-- <div class="home-operate__copy"><p>复制</p></div>
    <div class="home-operate__auth"><p>合体</p></div>
    <div class="home-operate__fit"><p>授权</p></div> -->
    <div class="home-operate__delete" @click="del">删除</div>
  </div>
</template>
<script>
export default{
  name: 'Home-More-Operate',
  props: {
    aiId:{
      type: Number,
      require: true
    },
    userId:{
      type: Number,
      require: true
    },
    aiName:{
      type: String,
      require: true
    }
  },
  data() {
    return {
      // property: 'value',
    };
  },
  methods: {
    edit() {
      this.$bus.$emit('createAi', true, this.aiId)
    },
    del() {
      this.$confirm(`确定删除“${this.aiName}”?`, '删除AI', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        // 删除AI
        this.$http.post('/aigenai/allAi/delete', {aiId: this.aiId, userId: this.userId}).then(
          res => {
            if (res.code !== 0) {return}
            this.$message({ type: 'success', message: '删除成功!' });
            this.$store.dispatch('getAllList')
          }
        ).catch(err=>{console.log('err', err)})
      }).catch(()=>{
        this.$message({ type: 'info', message: '取消删除' });  
      })
    },
  }
}
</script>
<style lang="less" scoped>
.home-operate{
  position: absolute;
  display: flex;
  flex-direction: column;
  min-width: 150px;
  min-height: 50px;
  top: 30px;
  left: 15px;
  background-color: #f4f4f4;
  cursor: auto;
  z-index: 1;
  :hover{
    /* font-size: 20px; */
    /* background-color: #959595; */
    background-color: #ff0000;
  }
  &__edit{
    cursor: pointer;
    margin: 5px 0 5px 10px;
  }
  &__delete{
    cursor: pointer;
    margin: 5px 0 5px 10px;
  }
}
</style>